import React from "react";
import { MDXRemote } from "next-mdx-remote";
import { Mermaid, Pre } from "@portaljs/core";
import Index from "components/home/Index.jsx"
import layouts from "../layouts";
import Resolution from "components/case-studies/Resolution.jsx"
import Tech from "components/case-studies/Tech.jsx"
import Callout from "components/case-studies/Callout.jsx"
import Quote from "components/case-studies/Quote.jsx"
import Subscribe from "components/SubscribeLanding.jsx"
import Newsletter from 'components/newsletter/Newsletter.jsx'
import Zoom from "./ZoomModal.jsx";
import Key from 'components/blog/Key'
import Note from 'components/blog/Note'
import Faq from 'components/blog/Faq'
import Contact from "./contact/ContactBrevo";
// Custom components/renderers to pass to MDX.
// Since the MDX files aren't loaded by webpack, they have no knowledge of how
// to handle import statements. Instead, you must include components in scope
// here.
const components = {
  mermaid: Mermaid,
  pre: Pre,
  img: (props) => <img {...props} className="shadow-lg rounded-xl" />,
  Index: Index,
  Tech: Tech,
  Resolution: Resolution,
  Callout: Callout,
  Quote: Quote,
  Contact: Contact,
  Subscribe: Subscribe,
  Newsletter: Newsletter,
  Zoom: Zoom,
  Key: Key,
  Note: Note,
  Faq: Faq
};

const options = {
  mdxOptions: {
    remarkPlugins: [],
    rehypePlugins: []
  }
}


export default function MdxPage({ source, frontMatter }) {
  const Layout = ({ children }) => {
    if (frontMatter.layout) {
      const LayoutComponent = layouts[frontMatter.layout];
      return <LayoutComponent {...frontMatter}>{children}</LayoutComponent>;
    }
    return <>{children}</>;
  };
  return (
    <main id="mdxpage" className="">
      <Layout>
        <MDXRemote {...source} components={components} />
      </Layout>
    </main>
  );
}
